import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { toFixedWithoutRounding } from "../../Utils/constants";

const Account = () => {
  const navigate = useNavigate();

  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader,
  );
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div id="mc-app-home-root" className="mc">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-home mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg className="am-icon am-icon-left am-icon-lg">
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">My Account</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="n-home-container">
          <div className="n-home-header">
            <div
              className="default-member-wrapper"
              style={{
                background:
                  profileData?.userLevel - 1 > 0
                    ? "linear-gradient(248deg, rgb(255, 236, 170) 0%, rgb(230, 177, 75) 100%)"
                    : `linear-gradient(248deg, rgb(241, 249, 255) 0%, rgb(179, 188, 200) 100%)`,
              }}
            >
              <div className="default-vip-icon">
                <img src="/assets/images/lv9.be016011.png" alt />
              </div>
              <div className="default-member-header">
                <div className="profile-icon">
                  <img
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png"
                    alt
                  />
                  {/* react-empty: 9466 */}
                </div>
                <div className="member-info">
                  <div className="vip-tag">
                    <div className="vip-img">
                      <img src="/assets/images/lv9.be016011.png" alt />
                    </div>
                    <div className="vip-name">
                      VIP {profileData?.userLevel - 1}
                    </div>
                  </div>
                  <div className="account-wrapper">
                    <span>{user?.user?.username}</span>
                    <svg className="am-icon am-icon-icon-copy_17d4102f am-icon-md">
                      <use xlinkHref="#icon-copy_17d4102f" />
                    </svg>
                  </div>
                  <div className="nickname-wrapper">
                    <div className="nickname-info">
                      <span className="info-title">
                        {/* react-text: 9314 */}Nickname{/* /react-text */}
                        {/* react-text: 9315 */}: {/* /react-text */}
                      </span>
                      <span className="name-text">{user?.user?.username}</span>
                    </div>
                    <Link
                      to="/member/profile"
                      className="go-to-edit"
                      href="/m/myAccount/nickName"
                    >
                      <svg className="am-icon am-icon-icon-edit_68c0ffef am-icon-md">
                        <use xlinkHref="#icon-edit_68c0ffef" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="default-member-mid">
                <div className="amount-balance-common current-wallet">
                  <span className="currency ">৳</span>
                  {/* react-text: 9323 */}&nbsp;{/* /react-text */}
                  <span className="number-mc undefined">
                    {toFixedWithoutRounding(userCoins?.balance) || 0}
                  </span>
                </div>
                <div onClick={amounutRefresh} className="refresh-btn">
                  <svg
                    className={`am-icon am-icon-refresh_e506c375 am-icon-md refresh-balance ${
                      refreshAmountLoader ? "loading" : ""
                    }`}
                  >
                    <use xlinkHref="#refresh_e506c375" />
                  </svg>
                </div>
              </div>
              <div className="default-member-footer-wrapper">
                <div className="member-arrow" />
                <div className="default-member-footer-wrap">
                  <div className="default-member-footer equal">
                    <Link to="/member/deposit" className="footer-item">
                      <span>Deposit</span>
                    </Link>
                    <Link
                      to={"/member/withdraw"}
                      rel="nofollow me noopener noreferrer"
                      className="footer-item"
                    >
                      Withdrawal
                    </Link>
                    {/* <Link to={"/member/cards"} className="footer-item">
                      My Cards
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="member-home-root"
            style={{ "min-height": "calc(-280.933px + 100vh)" }}
          >
            <div>
              <div className="n-nav-list-title">
                <span>Member Center</span>
              </div>
              <div className="mc-flex mc-flex-between mc-flex-row main-nav-list">
                <Link
                  to={"/member/rewardCenter"}
                  className="REWCEN3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-AGETEAMPNL3_a62d89c9 am-icon-lg">
                        <use xlinkHref="#AGETEAMPNL3_a62d89c9" />
                      </svg>
                      <div className="un-read-count">2</div>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Reward Center</span>
                </Link>
                <Link
                  to={"/member/gameCenter"}
                  className="TRANSBETREPMEM3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-TRANSBETREPMEM3_0d83fc3f am-icon-lg">
                        <use xlinkHref="#TRANSBETREPMEM3_0d83fc3f" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Betting Record</span>
                </Link>
                <Link
                  to="/member/profitandloss"
                  className="PERSPNL3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-PERSREP_9e354430 am-icon-lg">
                        <use xlinkHref="#PERSREP_9e354430" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Profit And Loss</span>
                </Link>
                {/* <Link
                  to="/member/real-time-bonus"
                  className="PERSPNL3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-PERSREP_9e354430 am-icon-lg">
                        <use xlinkHref="#PERSREP_9e354430" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">User Loss Bonus</span>
                </Link> */}
                
                <Link
                  to="/member/depositRecord"
                  className="DEPRECM3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-deposit_record_b99e1f01 am-icon-lg">
                        <use xlinkHref="#deposit_record_b99e1f01" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Deposit Record</span>
                </Link>
                <Link
                  to="/member/withdrawRecord"
                  className="WITHREC3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-withdraw_record_c986adfb am-icon-lg">
                        <use xlinkHref="#withdraw_record_c986adfb" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Withdrawal Record</span>
                </Link>
                <Link
                  to={"/member/accountRecord"}
                  className="TRANSREC3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-TRANSREC3_fcac856d am-icon-lg">
                        <use xlinkHref="#TRANSREC3_fcac856d" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Account Record</span>
                </Link>
                <Link
                  to={"/member/profile"}
                  className="MYACC main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-MYACC_a7ef046a am-icon-lg">
                        <use xlinkHref="#MYACC_a7ef046a" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">My Account</span>
                </Link>
                <Link
                  to="/member/securityCenter"
                  className="SECPRIV main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-SECPRIV_3f9a598c am-icon-lg">
                        <use xlinkHref="#SECPRIV_3f9a598c" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Security Center</span>
                </Link>
                <Link
                  to="/member/inviteFriends"
                  className="REFERRAL main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-REFERRAL_9586116f am-icon-lg">
                        <use xlinkHref="#REFERRAL_9586116f" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Invite Friends</span>
                </Link>
                <Link
                  to="/member/turnover"
                  className="MANPLAYREB3 main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-MANPLAYREB3_da78e50e am-icon-lg">
                        <use xlinkHref="#MANPLAYREB3_da78e50e" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Turnover</span>
                </Link>
                <Link
                  to="/member/spin-report"
                  className="MAILCEN main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-MAILCEN_4962dbe3 am-icon-lg">
                        <use xlinkHref="#MAILCEN_4962dbe3" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Spin Report</span>
                </Link>
                {/* <a className="FEEDBACK3 main-nav-style mcm-teampandect ">
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-FEEDBACK3_df31c81c am-icon-lg">
                        <use xlinkHref="#FEEDBACK3_df31c81c" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Suggestion</span>
                </a> */}
                <a className="APPDOWNLOAD main-nav-style mcm-teampandect ">
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-APPDOWNLOAD_44ccdfbb am-icon-lg">
                        <use xlinkHref="#APPDOWNLOAD_44ccdfbb" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Download APP</span>
                </a>
                <Link
                  to="/customer-support"
                  className="OPENHOURSSERVE main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-open_hours_141ce365 am-icon-lg">
                        <use xlinkHref="#open_hours_141ce365" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Customer Service</span>
                </Link>
                {/* 
                <a className="HELPCENTER main-nav-style mcm-teampandect ">
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-HELPCENTER_c45f2a56 am-icon-lg">
                        <use xlinkHref="#HELPCENTER_c45f2a56" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Help Center</span>
                </a> */}
                <a
                  onClick={() => logoutUser()}
                  className="LOGOUT main-nav-style mcm-teampandect "
                >
                  <div className="n-linear-border">
                    <div>
                      <svg className="am-icon am-icon-logout_bfa9feaf am-icon-lg">
                        <use xlinkHref="#logout_bfa9feaf" />
                      </svg>
                    </div>
                  </div>
                  <br />
                  <span className="main-text">Logout</span>
                </a>
              </div>
              <div className="mc-flex mc-flex-between mc-flex-row main-nav-list" />
            </div>
          </div>
        </div>
        {/* react-empty: 9449 */}
      </div>
    </div>
  );
};

export default Account;
